/** @jsx jsx */
import { Image, jsx } from 'theme-ui'
import PropTypes from 'prop-types'

const CustomImage = ({ data, id }) => {
  const { description, file } = data.fields.embed.fields
  return (
    <Image
      variant="special"
      src={`http:${file.url}`}
      alt={description}
      sx={{ fontSize: 16, mb: 5 }}
      id={id}
    />
  )
}

CustomImage.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
}

export default CustomImage
